<template></template>

<script>
import lotteryimg from "@c/lotteryimg";
import selectedDate from "@c/selectedDate";

export default {
  components: { selectedDate },
  data() {
    return {
      queryLotteryTypeCode: "", // 彩票大类
      queryLotteryCode: "", // 彩票code
      lotteryimg, // 彩票号码图片
      pageIndex: 1, // 只是显示用  初始分页数字
    };
  },
  // watch: {
  //   nowandover: {},
  // },
  methods: {
    async endCountDown(item, date) {
      console.log("归零了", date);
      item.status = "next";
      //没有current 说明还未开盘
      if (item.current == undefined && this.loadingnew == false) {
        //开盘时间到立刻取数据 不等20s
        this.loadingnew = true;
        console.warn("开盘时间到立刻取数据 不等20s", this.lotteryCode);
        await this.$store.dispatch("lottery/getLotteryLatelyLoop");
        this.loadingnew = false;
      }

      this.$store.commit(
        "lottery/setperiodsNumber",
        item[item.status].periodsNumber
      );
    },
    // 改变页码
    handleCurrentChange(n) {
      this.pageIndex = n;
      this.$store.commit("lottery/setPage", n);
      this.$store.commit(
          "lottery/setHisLotteryList", []
        );
      this.$store.dispatch("lottery/queryHisPeriodsPage");
    },
    changepageindex() {
      this.pageIndex = 1;
    },
  },
  computed: {
    // 计算当前多少期和还剩多少期
    nowandover() {
      let lotteryList = this.lotteryList;
      let TimeList = this.lotteryLatelyLpVo;
      let newList = [];
      lotteryList.forEach((lottery, index) => {
        if (lottery.lotteryCode == this.queryLotteryCode) {
          newList.push(Object.assign({}, lottery, TimeList));
          console.log(newList);
          return newList;
        }
      });
    },
    // 所有彩种查当前彩种
    nowLotteryList() {
      let list = this.$store.state.lottery.lotteryList || [];
      let nowLotteryList = list.find((e) => {
        return e.lotteryCode == this.lotteryCode;
      });
      return nowLotteryList || null;
    },
    // 当前彩票类别
    lotteryTypeCode() {
      return this.$store.state.lottery.lotteryTypeCode;
    },
    // 当前页
    page() {
      return this.$store.state.lottery.page;
    },
    // 总条数
    totalCount() {
      return this.$store.state.lottery.totalCount;
    },
    // 当前彩票code
    lotteryCode() {
      return this.$store.state.lottery.lotteryCode;
    },
    // 当前的具体彩票开奖信息
    lottery() {
      let list = this.$store.state.lottery.LotteryLatelyLpVo || [];
      let lottery = list.find((e) => {
        return e.lotteryCode == this.lotteryCode;
      });
      return lottery || null;
    },
    //开奖时间应该显示哪一期啊
    lotteryOpenPeriods() {
      // 如果开奖倒计时目前是当前期 说明有当前期
      if (this.lottery.status == "current") {
        return this.lottery.last;
      } else if (this.lottery.status == "next" && this.lottery.current) {
        //未开盘没有current
        return this.lottery.current;
      } else if (this.lottery.status == "next") {
        return this.lottery.last;
      } else {
        //啥都没？？？
        console.warn("啥都没？？？");
        return false;
      }
    },
    // 开奖历史
    hisLotteryList() {
      return this.$store.state.lottery.hisLotteryList;
    },
    // pk10
    // 开奖号码(arr[arr])
    lotteryNum() {
      return this.$store.state.lottery.lotteryNum;
    },
  },
  watch: {
    $route(to, from) {
      this.queryLotteryTypeCode = this.$route.query.lotteryTypeCode || "PK10";
      this.queryLotteryCode = this.$route.query.lotteryCode || "XYFT";
      this.$store.commit(
          "lottery/setHisLotteryList", []
        );
      this.$store.dispatch("lottery/queryHisPeriodsPage"); // 获取开奖历史
      this.$store.commit(
        "lottery/setlotteryTypeCode",
        this.queryLotteryTypeCode
      );
      this.$store.commit("lottery/setlotteryCode", this.queryLotteryCode);
    },
    "lottery.status"() {
      console.log("倒计时lottery.status改变");
    },
  },
  mounted() {
    this.queryLotteryTypeCode = this.$route.query.lotteryTypeCode || "";
    this.queryLotteryCode = this.$route.query.lotteryCode || "";
    this.$store.commit("lottery/setlotteryTypeCode", this.queryLotteryTypeCode);
    this.$store.commit("lottery/setlotteryCode", this.queryLotteryCode);
    this.$store.commit(
          "lottery/setHisLotteryList", []
        );
    this.$store.dispatch("lottery/queryHisPeriodsPage"); // 获取开奖历史
    this.$store.dispatch("lottery/getLotteryLatelyLoop"); // 定时任务
    this.$store.dispatch("lottery/getLotterylist"); // 所有彩种
  },
  beforeDestroy() {
    this.$store.commit("lottery/setLotteryLatelyLpVo", []);
    this.$store.commit("lottery/clearLotteryLatelyTimer");
    this.$store.commit("lottery/setPage", 1);
  },
};
</script>